export enum DocumentStatusEnum {
  NOT_UPLOADED = 'not uploaded',
  APPROVED = 'approved',
  ANALYZING = 'analyzing',
  DISAPPROVED = 'disapproved'
}
